export default "__VITE_ASSET__BwIHOLjY__"